export default {"src":"/_next/static/media/replay.164c0471.svg","height":602,"width":1017,"blurWidth":0,"blurHeight":0};